import { useAudienceJoinCountStore } from '@mentimeter/audience-join-count';
import { useQuestionResults, useQuestion } from '../../../data-mediation';
import { useParticipationDetails } from '../../../slide-layout/zoom-in-out/participation-details-sidebar/useParticipationDetails';
import { getCategory } from '../../../utils/category';
import { RespondentsIndicator } from './RespondentsIndicator';

export const RespondentsIndicatorDataHandler = () => {
  const { shouldHideRespondentsIndicator } = useParticipationDetails();
  const { respondents = 0 } = useQuestionResults() ?? {};
  const audienceMemberCount = useAudienceJoinCountStore((state) => state.count);

  const { type } = useQuestion();
  const category = getCategory(type);

  if (shouldHideRespondentsIndicator) {
    return null;
  }

  if (category === 'quiz') {
    return null;
  }

  if (category === 'interactive') {
    return (
      <RespondentsIndicator
        respondentCount={respondents}
        audienceMemberCount={audienceMemberCount}
      />
    );
  }

  // qfa and content slides
  return (
    <RespondentsIndicator
      respondentCount={undefined}
      audienceMemberCount={audienceMemberCount}
    />
  );
};
